import React from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../../../components/Icons/CloseIcon';
import DispatchStatusComponent from '../../../components/TableCom/TableCustomCellComponents/DispatchStatusComponent';
import { ICrmDetailResponse } from '../../../models/crm/crmDetails';
import { formateDatimeStrToNiajaTime } from '../../../utils/utils';

interface ICrmDetails {
  data?: ICrmDetailResponse;
  onClickHandler: (...args: any[]) => void;
}

const CrmDetails: React.FC<ICrmDetails> = ({ data, onClickHandler }) => {
  return (
    <>
      {data && (
        <Container>
          <SegmentWrapper className="top">
            <HeaderSection>
              Package Details
              <IconWrapper onClick={onClickHandler}>
                <CloseIcon />
              </IconWrapper>
            </HeaderSection>
            <DetailsSection>
              {/* <DetailsHeader>Details</DetailsHeader> */}
              <ContentRow>
                <div>Status</div>
                <DispatchStatusComponent>
                  {data?.status || 'N/A'}
                </DispatchStatusComponent>
              </ContentRow>
              <ContentRow>
                <div>Product Id</div>
                <div>{data.packageId || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Airwaybill number</div>
                <div>{data.airWayBillNumber || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Return state</div>
                {/* <div>{data.}</div> */}
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
          <SegmentWrapper>
            <DetailsSection>
              <DetailsHeader>Warehouse Details</DetailsHeader>
              <ContentRow>
                <div>Scanned in by</div>
                <div>{data.storedAtWarehouseBy || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Checked in by</div>
                <div>{data.storedAtWarehouseBy || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Scanned out by</div>
                <div>{data.scannedOutByManager || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Checked out by</div>
                <div>
                  {formateDatimeStrToNiajaTime(data.createdAt) || 'N/A'}
                </div>
              </ContentRow>
              <ContentRow>
                <div>Warehouse Arrival date:</div>
                <div>
                  {formateDatimeStrToNiajaTime(data.createdAt) || 'N/A'}
                </div>
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
          <SegmentWrapper>
            <DetailsSection>
              <DetailsHeader>Clearance Details</DetailsHeader>
              <ContentRow>
                <div>Withheld</div>
                <div>{data.withheld || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Package Detail</div>
                {/* <div>{data.pa|| 'N/A'}</div> */}
              </ContentRow>
              <ContentRow>
                <div>Package weight</div>
                <div>{data.weight || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Cleared by</div>
                {/* <div>{data.by || 'N/A'}</div> */}
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
          <SegmentWrapper>
            <DetailsSection>
              <DetailsHeader>Delivery Details</DetailsHeader>
              <ContentRow>
                <div>Delivery by</div>
                <div>{data.deliveredBy || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Delivery Date</div>
                <div>{data.deliveryDate || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Delivery Nipost code</div>
                <div>{data.deliveryZipCode || 'N/A'}</div>
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
          <SegmentWrapper>
            <DetailsSection>
              <DetailsHeader>Receivers Details</DetailsHeader>
              <ContentRow>
                <div>Receivers Name</div>
                <div>{data.deliveryDate || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>{`Receiver’s Number`}</div>
                <div>{data.customerPhoneNumber || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>{`Receiver’s Email Address`}</div>
                <div>{data.customerEmail || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>{`Receiver’s Address`}</div>
                <div>{data.deliveryAddress || 'N/A'}</div>
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
        </Container>
      )}
    </>
  );
};

export default CrmDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SegmentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-bottom: 3rem;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 2px solid yellow; */
  width: 100%;
  font-size: 1.125rem;
  font-weight: 500;
  color: #1f1f30;
`;

const DetailsSection = styled.div`
  font-size: 0.825rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DetailsHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
  color: ${({ theme }) => theme.palette.blackPrimary};
`;

const ContentRow = styled.div`
  display: flex;
  gap: 7rem;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
